const logotext = "DYLAN CORSO";
const meta = {
    title: "Dylan Corso",
    description: "Dylan Corso — Graphic Design Portfolio. Trinity University, COMM 3442.",
};

const introdata = {
    title: "I'm Dylan Corso",
    animated: {
        first: "I design posters",
        second: "I design magazine layouts",
        third: "I design logos & packaging",
    },
    description:
        "Graphic design student at Trinity University. A collection of poster, magazine, logo, packaging, and (re)design work from COMM 3442.",
    your_img_url: "/projects/logo-mockup.jpg",
};

const dataabout = {
    title: "A bit about me",
    aboutme:
        "I'm Dylan Corso, a student at Trinity University studying graphic design. This portfolio is the culmination of work from COMM 3442 — Graphic Design Principles, taught by Dr. Melissa McMullen. Across the semester I explored form, structure, color, type, and image through a series of printed pieces: a (re)design, posters, a magazine layout, packaging, and a logo. Each project pushed me to think more carefully about how visual choices shape a message.",
};

const worktimeline = [
    { jobtitle: "Logo Design — Good Grad", where: "COMM 3442", date: "Spring 2026" },
    { jobtitle: "Magazine Layout", where: "COMM 3442", date: "Spring 2026" },
    { jobtitle: "Poster Series & (Re)design — Otherwild", where: "COMM 3442", date: "Spring 2026" },
    { jobtitle: "Packaging — Soda Can", where: "COMM 3442", date: "Spring 2026" },
];

const skills = [
    { name: "Adobe InDesign", value: 85 },
    { name: "Adobe Photoshop", value: 85 },
    { name: "Adobe Illustrator", value: 85 },
    { name: "Typography", value: 80 },
    { name: "Layout & Composition", value: 80 },
];

const services = [
    {
        title: "Print & Editorial Design",
        description: "Posters, magazine layouts, and other printed pieces designed with attention to grid, type, and image.",
    },
    {
        title: "Logo & Identity",
        description: "Mark-making and identity work focused on simplicity, scalability, and meaning.",
    },
    {
        title: "Packaging Design",
        description: "Product packaging that communicates brand and shelf appeal through form, color, and type.",
    },
];

const dataportfolio = [
    {
        slug: "good-grad-logo",
        title: "Good Grad — Logo Design",
        category: "Logo",
        img: "/projects/logo-mockup-thumb.jpg",
        hero: "/projects/logo-mockup.jpg",
        description:
            "A logo redesign for Good Grad. The final mark balances a clean, grown-up feel with a friendly approachability that suits the brand.",
        pieces: [
            { label: "Final mockup", img: "/projects/logo-mockup.jpg" },
            { label: "Final logo", img: "/projects/logo-final.jpg" },
            { label: "Original logo (before)", img: "/projects/logo-before.jpg" },
        ],
    },
    {
        slug: "magazine-layout",
        title: "Magazine Layout",
        category: "Editorial",
        img: "/projects/mag-mockup-thumb.jpg",
        hero: null,
        layout: "pairs",
        description:
            "A multi-spread magazine layout. Working from a tight grid, I rebuilt the original spreads with a stronger hierarchy, more confident typography, and improved image placement.",
        pieces: [
            { label: "Final spread — page 1", img: "/projects/mag-final-p1.jpg" },
            { label: "Final spread — page 2", img: "/projects/mag-final-p2.jpg" },
            { label: "Before — spread 1, page 1", img: "/projects/mag-before-1-p1.jpg" },
            { label: "Before — spread 1, page 2", img: "/projects/mag-before-1-p2.jpg" },
            { label: "Before — spread 2, page 1", img: "/projects/mag-before-2-p1.jpg" },
            { label: "Before — spread 2, page 2", img: "/projects/mag-before-2-p2.jpg" },
        ],
    },
    {
        slug: "otherwild-posters",
        title: "Otherwild — Poster Series & Redesign",
        category: "Poster / Redesign",
        img: "/projects/poster-1-thumb.jpg",
        hero: null,
        layout: "pairs",
        description:
            "A two-poster series for Otherwild that doubled as my (re)design project. The original print needed stronger type and image hierarchy; the final pair leans on bold collage type and a restrained palette to read as a unified set.",
        pieces: [
            { label: "Poster 1 — final mockup", img: "/projects/poster-1.jpg" },
            { label: "Poster 2 — final mockup", img: "/projects/poster-2.jpg" },
            { label: "Original artwork (before)", img: "/projects/redesign-before.jpg" },
            { label: "Final artwork (after)", img: "/projects/redesign-after.jpg" },
        ],
    },
    {
        slug: "soda-can-packaging",
        title: "Soda Can — Packaging",
        category: "Packaging",
        img: "/projects/can-mockup-thumb.jpg",
        hero: "/projects/can-mockup.jpg",
        description:
            "Packaging design for a soda can. Iterated from an early concept (Can 100) into a refined final label (Can 101) and presented in a chilled, real-world mockup.",
        pieces: [
            { label: "Final mockup", img: "/projects/can-mockup.jpg" },
            { label: "Final label", img: "/projects/can-final.jpg" },
            { label: "Original concept (before)", img: "/projects/can-before.jpg" },
        ],
    },
];

const contactConfig = {
    YOUR_EMAIL: "claude@texassportsproductions.com",
    YOUR_FONE: "",
    description:
        "Get in touch about design work, collaborations, or internship opportunities. The fastest way to reach me is by email.",
    YOUR_SERVICE_ID: "service_id",
    YOUR_TEMPLATE_ID: "template_id",
    YOUR_USER_ID: "user_id",
};

const socialprofils = {
    github: "https://github.com",
    facebook: "https://facebook.com",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com",
};

export {
    meta,
    dataabout,
    dataportfolio,
    worktimeline,
    skills,
    services,
    introdata,
    contactConfig,
    socialprofils,
    logotext,
};
